import {
  ComponentTypeFactory,
  FieldTypeFactory,
} from '@sentecacommerce-theme/base'
import { ContactsPageProps } from './contactsPage.props'

export const ContactsPageType = ComponentTypeFactory.create<ContactsPageProps>(
  'ContactsPage',
  {
    image: FieldTypeFactory.image(),
    isDev: FieldTypeFactory.boolean({ required: false }),
    imageAlt: FieldTypeFactory.text({ required: true }),
    contactsCTA: {
      link: FieldTypeFactory.text({ required: true }),
      label: FieldTypeFactory.text({ required: true }),
    },
    title: FieldTypeFactory.text({ required: true }),
    contactsTitle: FieldTypeFactory.text({ required: true }),
    formTitle: FieldTypeFactory.text({ required: true }),

    contactsContent: FieldTypeFactory.list({
      of: {
        content: FieldTypeFactory.html({ required: true }),
      },
    }),

    formGDPR: {
      label: FieldTypeFactory.text({ required: true }),
      modalContent: FieldTypeFactory.html({ required: true }),
      linkLabel: FieldTypeFactory.text({ required: true }),
    },

    labels: {
      nameInputLabel: FieldTypeFactory.text({ required: true }),
      emailInputLabel: FieldTypeFactory.text({ required: true }),
      phoneInputLabel: FieldTypeFactory.text({ required: true }),
      aboutInputLabel: FieldTypeFactory.text({ required: true }),
      questionInputLabel: FieldTypeFactory.text({ required: true }),
      fieldIsRequired: FieldTypeFactory.text({ required: true }),
      invalidEmail: FieldTypeFactory.text({ required: true }),
      sendLabel: FieldTypeFactory.text({ required: true }),
      errorMessage: FieldTypeFactory.text({ required: true }),
      successMessage: FieldTypeFactory.text({ required: true }),
    },
    centralStore: {
      name: FieldTypeFactory.text({ required: true }),
      phoneNumber: FieldTypeFactory.text({ required: true }),
      email: FieldTypeFactory.text({ required: false }),
    },
  }
)
